// extracted by mini-css-extract-plugin
module.exports = {"compact":"longtext_compact__lFfMw","block":"longtext_block__q20vl"};